import React, { FC } from 'react';
import styles from './organizationModal.module.scss';
import OrganizationModal from 'shared/components/OrganizationModal';
import { Formik, Form } from 'formik';
import { Col, Row } from 'antd';
import COSelect from 'shared/components/COSelect';
import COButton from 'shared/components/COButton';
import yearFormValidationSchema from './addYearFormValidation';
import { baseYear } from 'constants/constants';
import { getYearOptions } from 'shared/utils/currentYearsList';
import { ButtonSize } from 'enums/ButtonEnums';
import { OptionsMeta } from 'models/MetaData/metaData.model';

interface EditOrganisationMapModalsProps {
  isYearModalOpen: boolean;
  isDuplicateModalOpen: boolean;
  handleCloseModal: () => void;
  handleSubmit: (values?: { year?: string }) => void;
  organisationYearsList: OptionsMeta[];
  loading?: boolean;
  activeYear: string;
}

const EditOrganisationMapModals: FC<EditOrganisationMapModalsProps> = props => {
  const {
    isYearModalOpen,
    isDuplicateModalOpen,
    handleCloseModal,
    handleSubmit,
    loading,
    activeYear,
    organisationYearsList,
  } = props;

  const availableYears = organisationYearsList?.filter(
    item => item?.value?.toString() !== activeYear
  );

  const initialValues = {
    year: String(isYearModalOpen ? baseYear : availableYears?.[0]?.value),
  };

  const yearOptions = getYearOptions();

  return (
    <div className={styles.yearModalContainer}>
      <OrganizationModal
        visible={isYearModalOpen || isDuplicateModalOpen}
        onClose={handleCloseModal}
        children={
          <div className={styles.modalContainer}>
            <div className={styles.modalTitle}>
              {isYearModalOpen
                ? 'Add Year'
                : 'Duplicate map from particular year'}
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={yearFormValidationSchema(
                isYearModalOpen ? organisationYearsList : []
              )}
              onSubmit={handleSubmit}>
              <Form>
                <div className={styles.yearFormContainer}>
                  <Row gutter={12}>
                    <Col span={24}>
                      <COSelect
                        name="year"
                        placeholderstring="Year"
                        label={isYearModalOpen ? 'Add year' : 'Choose year'}
                        options={isYearModalOpen ? yearOptions : availableYears}
                        listHeight={100}
                      />
                    </Col>
                  </Row>
                </div>
                <div className={styles.yearFormButtonContainer}>
                  <Row gutter={16}>
                    <Col span={12}>
                      <COButton
                        primary
                        size={ButtonSize.LARGE}
                        loading={loading}
                        submit>
                        Submit
                      </COButton>
                    </Col>
                    <Col span={12}>
                      <COButton
                        secondary
                        onClick={handleCloseModal}
                        size={ButtonSize.LARGE}>
                        Back
                      </COButton>
                    </Col>
                  </Row>
                </div>
              </Form>
            </Formik>
          </div>
        }
      />
    </div>
  );
};

export default EditOrganisationMapModals;
